/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getEmploiInformationInscriptionActions, {
    getEmploiInformationInscriptionTypes,
} from '../../../../redux/editique/donneesEmploi/getEmploiInformationInscription'
import { Get } from '../../../../serveur/axios'

function* getEmploiInformationInscriptionSagas({ response }) {
    const {
        governorate,
        delegation,
        bureauEmploi,
        from,
        to,
        fromSecondary,
        toSecondary,
    } = response

    let url = '/editique-emploi/emploi_information_inscription?'

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }
    if (delegation) {
        url = `${url}&delegation=${delegation}`
    }
    if (bureauEmploi) {
        url = `${url}&bureau_emploi=${bureauEmploi}`
    }
    if (from) {
        url = `${url}&from=${from}`
    }
    if (to) {
        url = `${url}&to=${to}`
    }
    if (fromSecondary) {
        url = `${url}&fromSecondary=${fromSecondary}`
    }
    if (toSecondary) {
        url = `${url}&toSecondary=${toSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getEmploiInformationInscriptionActions.getEmploiInformationInscriptionSuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getEmploiInformationInscriptionActions.getEmploiInformationInscriptionFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getEmploiInformationInscriptionActions.getEmploiInformationInscriptionFailure(
                error
            )
        )
    }
}

export function* getEmploiInformationInscriptionSaga() {
    yield takeLatest(
        getEmploiInformationInscriptionTypes.GET_EMPLOI_INFORMATION_INSCRIPTION_REQUEST,
        getEmploiInformationInscriptionSagas
    )
}
